
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography, TextField } from "@mui/material";


function Postcode({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  const [ value, setValue ] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    let inputValid = false;

    const alphanumericRegex = /^[a-z0-9]+$/i;
    inputValid = alphanumericRegex.test(inputValue) || inputValue === "";

    if (inputValid) {
      const upperCasedValue = inputValue.toUpperCase();
      setValue(upperCasedValue);
      setFormState({
        ...formState,
        [e.target.name]: upperCasedValue,
      });
      setFormError(null);
    }
  }

  return (
    <>
      <Typography
        id='postcodeLabel'
        component='label'
        htmlFor='postcodeInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='postcodeInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='postcode'
        onChange={onChange}
        value={value}
      />
    </>
  );
};

const validatePostcode = (postcode) => {
  const postcodeRegex = /^([A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2})$/i;
  return postcodeRegex.test(postcode);
};

Postcode.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { Postcode, validatePostcode };